import type { OwnerSuggestion } from '@/models/fillApplication'
import type { BusinessOwner, UpdateBusinessOwnerData } from '@/models/user'

/** What "Use these" saves: the owner's blank name, phone and date of birth. Never the email. */
export function suggestionFills(
  owner: BusinessOwner | null | undefined,
  suggestion: OwnerSuggestion
): UpdateBusinessOwnerData {
  const fills: UpdateBusinessOwnerData = {}
  if (!owner?.firstName && suggestion.firstName) fills.firstName = suggestion.firstName
  if (!owner?.lastName && suggestion.lastName) fills.lastName = suggestion.lastName
  if (!owner?.mobile && suggestion.phone) fills.mobile = suggestion.phone
  if (!owner?.dob && suggestion.dob) fills.dob = suggestion.dob
  return fills
}

export function suggestsOtherEmail(
  owner: BusinessOwner | null | undefined,
  suggestion: OwnerSuggestion
): boolean {
  return !!suggestion.email && suggestion.email.toLowerCase() !== (owner?.email ?? '').toLowerCase()
}

export function suggestionName(suggestion: OwnerSuggestion): string {
  return (
    [suggestion.firstName, suggestion.lastName].filter(Boolean).join(' ') || suggestion.email || 'This person'
  )
}
